module.exports = __webpack_public_path__ + "static/img/sctmBanner.41880622.png";